import 'jquery-simulate'

export default {
  init() {
    this.runWhatsTrendingSlider();

    /**
     * Carousel section
     * @author Javier Colmenárez
     * @const {Object}  basicSharedSlickConfig  - Configuration object to be extended for the Slick carousel instances
     */
    const basicSharedSlickConfig = {
      arrows: false,
      autoplay: true,
      cssEase: 'linear',
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    /**
     * Invoking the Slick carousel initiation method for the Sliders Section instances
     * Setting up both instances to be linked & synced upon every slide change animation
     */
    jQuery('.js-slider-section-categories-desc').slick({
      ...basicSharedSlickConfig,
      asNavFor: '.js-slider-section-categories-imgs',
      dots: true,
    });

    jQuery('.js-slider-section-categories-imgs').slick({
      ...basicSharedSlickConfig,
      asNavFor: '.js-slider-section-categories-desc',
    });

    /**
     * Rental HQ Favorites section - Dropdown logic
     * 1. Binding a event listener for the tabs shown flow in order to sync up the current active tab with the dropdown selected option
     * 2. Binding an onChange event listener for the dropdown in order to trigger the tab navigation
     */
    jQuery('.js-rentalhq-favs-main-nav-links').on('shown.bs.tab', evt => {
      const $select = jQuery('.js-favorites-dropdown');
      if (evt.target.id !== $select.val()){
        $select.children(`option[value=${evt.target.id}]`).attr('selected', 'selected');
      }
    });
    jQuery('.js-favorites-dropdown').change(evt => {
      jQuery(`#${evt.currentTarget.value}`).click();
    });
  },

  // whats trending carousel
  runWhatsTrendingSlider() {
    $('.home__whats-trending .category-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },

  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js